// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p9Yf","content":"styles_content__1ZUFM","tableWrap":"styles_tableWrap__lCAdj"};